const products = [
  {
    path: "/product/:sku",
    name: "/product/sku",
    component: () => import("@/views/ProductPage.vue"),
    meta: { requiresAuth: false, layout: "Main", title: "Product" },
  },
  {
    path: "/products/:abstractProductCode",
    name: "/products/abstractProductCode",
    component: () => import("@/views/ProductsPage.vue"),
    props: (route) => ({
      page: parseInt(route.query.page) || 1,
      abstractProductCode: route.params.abstractProductCode,
      sortField: route.query.sortField || "price",
      sortOrder: route.query.sortOrder || null,
      productAttributeValueCodes: route.query.productAttributeValueCodes || "",
      manufactureCodes: route.query.manufactureCodes || "",
      priceFrom: parseInt(route.query.priceFrom) || null,
      priceTo: parseInt(route.query.priceTo) || null,
    }),
    meta: { requiresAuth: false, layout: "Main", title: "Products" },
  },
  {
    path: "/store/:vendorLogin",
    name: "/store/vendorLogin",
    component: () => import("@/views/StorePage.vue"),
    props: (route) => ({
      page: parseInt(route.query.page) || 1,
      vendorLogin: route.params.vendorLogin,
      sortField: route.query.sortField || "price",
      sortOrder: route.query.sortOrder || "ASC",
      manufactureCodes: route.query.manufactureCodes || "",
      categoryCode: route.query.categoryCode || "",
      priceFrom: parseInt(route.query.priceFrom) || null,
      priceTo: parseInt(route.query.priceTo) || null,
    }),
    meta: { requiresAuth: false, layout: "Main", title: "Products" },
  },
  {
    path: "/store/about/:vendorLogin",
    name: "/store/about/vendorLogin",
    component: () => import("@/views/StoreAboutPage.vue"),

    meta: { requiresAuth: false, layout: "Main", title: "About Store" },
  },
];

export { products };
